import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface PurchaseNotification {
  name: string;
  city: string;
  country: string;
  timeAgo: string;
}
const purchases: PurchaseNotification[] = [{
  name: 'Martín L.',
  city: 'Buenos Aires',
  country: 'Argentina',
  timeAgo: 'hace 2 min'
}, {
  name: 'Camila R.',
  city: 'Medellín',
  country: 'Colombia',
  timeAgo: 'hace 4 min'
}, {
  name: 'Santiago P.',
  city: 'Ciudad de México',
  country: 'México',
  timeAgo: 'hace 5 min'
}, {
  name: 'Lucía F.',
  city: 'Santiago',
  country: 'Chile',
  timeAgo: 'hace 7 min'
}, {
  name: 'Andrés M.',
  city: 'Lima',
  country: 'Perú',
  timeAgo: 'hace 9 min'
}, {
  name: 'Valentina G.',
  city: 'Córdoba',
  country: 'Argentina',
  timeAgo: 'hace 11 min'
}, {
  name: 'Diego H.',
  city: 'Bogotá',
  country: 'Colombia',
  timeAgo: 'hace 13 min'
}, {
  name: 'Florencia S.',
  city: 'Montevideo',
  country: 'Uruguay',
  timeAgo: 'hace 15 min'
}, {
  name: 'Carlos A.',
  city: 'Guadalajara',
  country: 'México',
  timeAgo: 'hace 18 min'
}, {
  name: 'María José T.',
  city: 'Quito',
  country: 'Ecuador',
  timeAgo: 'hace 20 min'
}, {
  name: 'Nicolás V.',
  city: 'Rosario',
  country: 'Argentina',
  timeAgo: 'hace 23 min'
}, {
  name: 'Paula D.',
  city: 'San José',
  country: 'Costa Rica',
  timeAgo: 'hace 26 min'
}, {
  name: 'Fernando B.',
  city: 'Caracas',
  country: 'Venezuela',
  timeAgo: 'hace 28 min'
}, {
  name: 'Agustina K.',
  city: 'La Plata',
  country: 'Argentina',
  timeAgo: 'hace 31 min'
}, {
  name: 'Roberto C.',
  city: 'Panamá',
  country: 'Panamá',
  timeAgo: 'hace 34 min'
}];
export function FloatingTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const showNext = useCallback(() => {
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
      }, 500);
    }, 4000);
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNext();
    }, 6000);
    const interval = setInterval(() => {
      showNext();
    }, 8000 + Math.random() * 4000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [showNext]);
  const current = purchases[currentIndex];
  return <div className="fixed bottom-6 left-4 md:left-6 z-40 pointer-events-none" data-id="element-87">
      <AnimatePresence data-id="element-88">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 30,
        x: -10
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        x: -10
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="pointer-events-auto" data-id="element-89">
            <div className="flex items-center gap-3 px-4 py-3 rounded-lg shadow-2xl max-w-xs" style={{
          background: 'linear-gradient(135deg, rgba(26,26,46,0.95) 0%, rgba(13,13,26,0.95) 100%)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          backdropFilter: 'blur(12px)'
        }} data-id="element-90">
              <div className="w-8 h-8 rounded-full bg-brand-gold/20 flex items-center justify-center shrink-0" data-id="element-91">
                <span className="text-brand-gold text-sm" data-id="element-92">✓</span>
              </div>
              <div className="min-w-0" data-id="element-93">
                <p className="text-brand-ivory font-body text-sm font-medium leading-tight truncate" data-id="element-94">
                  {current.name}
                </p>
                <p className="text-brand-muted font-body text-[11px] leading-tight mt-0.5" data-id="element-95">
                  adquirió el sistema
                </p>
                <p className="text-brand-gold/70 font-body text-[10px] leading-tight mt-0.5" data-id="element-96">
                  {current.city}, {current.country} · {current.timeAgo}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}